<template>
  <div>
    <base-nav-pages
      type="bg-white-transp"
      expand
      content-id="number"
      id="iv-navbar"
      :sticky="sticky"
      :menuMobile="menuMobile"
      logo="https://upcdn.io/FW25b8h/raw/logos/rhomtrip/logo-rhomtrip-mobility-vn.png"
      logoClasses="min"
    >
      <div class="row" slot="content-header" slot-scope="{ closeMenu }">
        <div class="col-6 collapse-brand align-items-center">
          <a href="/">
            <img
              src="~rhomtrip_assets/src/img/brand/logo-rhomtrip-mobility.png"
              class="logo "
              alt="RhomTrip"
            />
          </a>
        </div>
        <div class="col-6 collapse-close align-items-center">
          <close-button @click="closeMenu" target="navbar-primary">
          </close-button>
        </div>
      </div>

      <!-- <hr class="hrmain d-lg-none" /> -->

      <!-- <ul class="d-none-desk menu-mobile">
        <li class="nav-item d-none-desk" v-if="!$store.state.sesion">
          <router-link class="nav-link" to="/" v-on:click.native="closeMenu"
            >Sign in</router-link
          >
        </li>
      </ul> -->

      <div class="navbar-right d-none d-lg-block ml-lg-auto">
				<div class="d-inline">
					<router-link to="/" class="nav-link-login d-inline-flex mr-2"
						>Sign in</router-link
					>
				</div>
			</div>
    </base-nav-pages>
  </div>
</template>
<script>
import BaseNavPages from "rhomtrip_assets/src/components/NavPages/BaseNavPages";
import { mapMutations, mapGetters, mapActions } from "vuex";
export default {
  name: "navmenu",
  components: {
    BaseNavPages
  },
  props: {
    menuMobile: {
      type: Boolean,
      default: true,
      description: "active menu mov"
    }
  },
  data() {
    return {
      codelang: "en",
      flag: "flag-icon-us",
      displayscroll: false,
      sticky: false,
      lang: "English",
      langMobile: "en",
      modalLanguage: false,
      languages: [
        {
          id: 1,
          lang: "English",
          flag: "flag-icon-us",
          codelang: "en"
        }
      ]
    };
  },
  computed: {
    ...mapGetters(["toggled", "sesion"])
  },
  created: function() {
    this.$store.dispatch("getSesion");
    if (this.sesion !== null) {
      let path = this.$route.path;
    }
  },

  mounted() {
    window.addEventListener("scroll", this.ScrollUp);
  },

  methods: {
    logout() {
      this.setSesion(null);

      this.$router.push("/");
    },

    topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.displayscroll = false;
      this.sticky = false;
    },

    ScrollUp() {
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        this.displayscroll = true;
        this.sticky = true;
      } else {
        this.displayscroll = false;
        this.sticky = false;
      }
    },

    closeMenu() {
      this.getToggledMenu(false);
    },
    setLocale(lang, flag) {
      localStorage.setItem("iv-local-lang", lang);
      this.$i18n.locale = lang;
      this.codelang = lang;
      this.flag = flag;
    },
    setLocaleOne(lang, flag) {
      // let language = this.languages.find((elemen) => elemen.id === id);
      // localStorage.setItem("iv-local-lang", language.lang);
      // this.$i18n.locale = language.lang;
      // this.codelang = language.codelang;
      // this.flag = language.flag;

      localStorage.setItem("iv-local-lang", lang);
      this.$i18n.locale = lang;
      this.codelang = lang;
      this.flag = flag;
      this.modalLanguage = false;
    },

    ...mapActions(["getToggledMenu"]),
    ...mapMutations(["setSesion", "setToggled"])
  }
};
</script>
